import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { RootState } from "../_store";
import { useSelector } from "react-redux";
import Moment from 'react-moment';
import { FILE_DOWNLOAD } from "../constants/endpoints";
import { Link } from "react-router-dom";

type NewsProps = {
    showInMainPage?: boolean
}

export default function NewsPage(props: NewsProps) {
    const { showInMainPage } = props;

    const news = useSelector((state: RootState) => state.news.news);

    const shortInfo = showInMainPage; // если true, значит показываем на главной краткую инфу о продукции

    const getNews = () => {

        if (shortInfo) {
            return news.slice(-1);
        }

        return news;
    }

    return (
        <Container className="page-container">
            <h2 className="page-container-header">Новости компании</h2>
            {getNews().map((oneNews) => (
                <Row style={{ paddingBottom: "30px" }} key={oneNews.id}>
                    <Col xs={6}>
                        <img src={`/api/${FILE_DOWNLOAD}?id=${oneNews.imageId}`}
                            style={{ width: "100%" }}
                            alt="conpany-news"></img>
                    </Col>
                    <Col>
                        <p>
                            <h4>{oneNews.headline}</h4>
                            <span><Moment format="DD.MM.YYYY">{oneNews.date}</Moment></span>
                        </p>
                        <p>
                            {oneNews.description}
                        </p>
                    </Col>
                </Row>
            )
            )}

            <hr></hr>

            {shortInfo &&
                <Row>
                    <Col xs={11}>
                    </Col>
                    <Col>
                        <Link to={`/news`}
                            style={{ float: "right", margin: "10px 0px 10px 0px" }}>Больше новостей...{'>'}</Link>
                    </Col>
                </Row>
            }

        </Container>
    )
}